import React, { Component } from 'react'
import { Modal, Button,Row,Col,Form,Image } from "react-bootstrap";
import loader from '../../images/loader.gif';
import CardLessDataTableWithSearch from '../datatables/CardLessDataTableWithSearch';


class HouseWiseVotersD2DModal extends Component {
    constructor(props) {
        super(props)
        this.state = {
        }
      
    }

    
    hoseWiseVoterListDisplayColumns() {
    let columns = [
        
        {
            dataField: "firstName",
            text: "Name",
            sort: true,
            headerStyle: {
                width: "50%"
            }
            
            
        },
        {
            dataField: "gender",
            text: "Gender",
            sort: true,
            headerStyle: {
                width: "20%"
            }
            
            
        },
        {
            dataField: "age",
            text: "Age",
            sort: true,
            headerStyle: {
                width: "10%"
            }
            
        },
        {
            dataField: "voterCardNumber",
            text: "Voter CardNo",
            sort: true,
            headerStyle: {
                width: "30%"
            }
            
        },
     
    ];
    return columns;
}


hoseWiseVoterListDisplayData = () =>{
    let houseWiseVoterData = [];
    var obj = {};
    var firstName="",gender="",age="",voterCardNumber="";

        if(this.props.stateData.houseWiseVotersArr.length>0){
            
            for (let i = 0; i < this.props.stateData.houseWiseVotersArr.length; i++) {

                if(this.props.stateData.houseWiseVotersArr[i].address.id == this.props.stateData.houseWiseVotersId){
                    if(this.props.stateData.houseWiseVotersArr[i].voters !=null && this.props.stateData.houseWiseVotersArr[i].voters.length>0){
                        for(var j in this.props.stateData.houseWiseVotersArr[i].voters){
                           firstName = (this.props.stateData.houseWiseVotersArr[i].voters[j].firstName);
                           gender = (this.props.stateData.houseWiseVotersArr[i].voters[j].gender);
                           age = (this.props.stateData.houseWiseVotersArr[i].voters[j].age);
                           voterCardNumber = (this.props.stateData.houseWiseVotersArr[i].voters[j].voterCardNumber);

                            obj = {
                                firstName:(firstName),
                                gender:gender,
                                gender: gender,
                                age: age,
                                voterCardNumber: voterCardNumber
                            }

                            houseWiseVoterData.push(obj);
                        }
                    }else{
                         obj = {
                                firstName:(firstName),
                                gender:gender,
                                gender: gender,
                                age: age,
                                voterCardNumber: voterCardNumber
                            }

                            houseWiseVoterData.push(obj);
                    }
                }
                
            } 

            
            
            return houseWiseVoterData;
        }
}



    
    render() {
        return (
            <Modal {...this.props} 
            size="md"  aria-labelledby="example-modal-sizes-title-lg" className="overView_video_play">
                <Modal.Header closeButton className='p-3'>
                    <Modal.Title className='f-14 fw-bold'>House Wise Voter List (House No : {this.props.stateData.houseNoForVoters}) : </Modal.Title>
                </Modal.Header>
                <Modal.Body className="">
                {
                            this.props.stateData.houseWiseVotersArr.length == 0 ?
                            (
                                this.props.stateData.houseWiseVoterCheck == 1 ?
                                (<Col className='f-14 text-center'>No Data Available</Col>)
                                :
                                (<Col sm={12}>
                                  <div class="spinner-border color_yellow loading-img-center mt-4"></div>
                                </Col>)
                            )
                            :
                            (
                              this.props.stateData.houseWiseVotersArr.length>0 ?
                                (
                                    <>
                                    <Row>
                                        <Col sm={12}>
                                        
                                        <div className='bg_light_blue mt-3 p-0'>
                                            
                                            <CardLessDataTableWithSearch 
                                                parentData={this.hoseWiseVoterListDisplayData()}
                                                particlecolumns={this.hoseWiseVoterListDisplayColumns()}
                                                defaultSorted={[{
                                                    dataField: "firstName",
                                                    order: "asc"
                                                }]}
                                                tableHeading=""
                                                />
                                            
                                                
                                        </div>
                                        
                                        </Col>
                                    </Row>
                                    </>
                                )
                                :
                                ("")
                            )
                          }

                </Modal.Body>
            </Modal>
            
        )
    }
}
export default HouseWiseVotersD2DModal;
  

